export const environment = {
  production: false,
  prestoUrl: 'https://presto-cloud.dev.presto-esl.d-p.io',
  sdpUrl: 'TBD-dev',
  eslUrl: 'TBD-dev',
  financingUrl: 'TBD-dev'
};
